var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 688,
    height: 68,
    viewBox: "0 0 688 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.848 66.032L29.936 50.864H22.352L17.36 66.032M5.168 66.032L10.256 50.864H2L5.36 40.4H13.808L17.936 27.728H9.584L12.848 17.36H21.488L26.576 2H38.768L33.68 17.36H41.168L46.256 2H58.448L53.264 17.36H61.712L58.544 27.728H49.808L45.584 40.4H54.32L51.056 50.864H42.032L37.04 66.032H84.7025V26.672L73.8545 37.424L62.9105 26L87.3905 2H104.095V66.032H686M33.392 40.4L37.616 27.728H30.128L26 40.4H33.392Z",
    stroke: "url(#paint0_linear_3332_1905)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3332_1905",
    x1: 2,
    y1: 34.016,
    x2: 686,
    y2: 34.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#BC15FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC15FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktop);
export default __webpack_public_path__ + "static/media/icon-desktop.58aabbc5951081f5516e4314a5bee1f5.svg";
export { ForwardRef as ReactComponent };